import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import _isNull from "lodash/isNull";
import _isUndefined from "lodash/isUndefined";
import _mapValues from "lodash/mapValues";
import _values from "lodash/values";
import { AnyAction } from "redux";
import phoneNumberReducer from "./phoneNumberReducer";
import subscriptionReducer from "./subscriptionReducer";
import { SubscriptionsState } from "../../../../../models/state";
import * as RETAILER_AT from "../../../retailer/state/actionTypes";
import { fulfilled, pending } from "../../utils";
import * as AT from "../actionTypes";

const getLegalSubscription = (subscriptions: SubscriptionsState) => {
    return _values(subscriptions).find((sub) => _get(sub, "isLegal", false));
};
const getLegalSubscriptionId = (subscriptions: SubscriptionsState) =>
    _get(getLegalSubscription(subscriptions), "id", null);

const initialState: SubscriptionsState = {};

const reducer = (state = initialState, action: AnyAction): SubscriptionsState => {
    // These global actions will generate new subscriptions object
    switch (action.type) {
        case fulfilled(AT.CHECKOUT_ADD_ACCESSORY_TO_CART):
            if (
                _isUndefined(_get(action, "payload.cart.subscriptions", undefined)) &&
                !_isNull(_get(action, "payload.cart.subscriptions"))
            ) {
                return state;
            }
            return {
                ...action.payload.cart.subscriptions,
            };
        case fulfilled(AT.CHECKOUT_ADD_SUBSCRIPTION_TO_CART):
            if (_isUndefined(action.payload?.subscriptions)) {
                return state;
            }
            return _mapValues(action.payload.subscriptions, (sub, key) => ({
                ...state[key],
                ...sub,
                // Explicitly take maxAgeAllowed from server response so stale age restrictions
                // from a previously selected age-restricted subscription don't persist.
                maxAgeAllowed: sub.maxAgeAllowed,
            }));
        case fulfilled(AT.CHECKOUT_REMOVE_ITEM_BY_ID_FROM_CART):
        case fulfilled(AT.CHECKOUT_ADD_SERVICE_TO_CART):
        case fulfilled(AT.CHECKOUT_ADD_EXTRA_SIM_TO_CART):
        case fulfilled(AT.CHECKOUT_REMOVE_ITEM_BY_CART_ITEM_ID_FROM_CART):
        case fulfilled(AT.CHECKOUT_FETCH_CART):
        case fulfilled(AT.CHECKOUT_ADD_WEBDEAL_ACCESSORY_TO_CART):
        case fulfilled(AT.CHECKOUT_SET_MEMBER_DETAILS):
        case fulfilled(AT.CHECKOUT_EMPTY_ORDER):
        case fulfilled(AT.CHECKOUT_EXTEND_ORDER):
        case fulfilled(AT.CHECKOUT_RESET_ORDER):
        case fulfilled(AT.CHECKOUT_SET_PERSONAL_DETAILS):
        case fulfilled(AT.CHECKOUT_SET_MAIN_SUBSCRIPTION):
        case fulfilled(AT.CHECKOUT_ADD_SUBSCRIPTION_IN_BUNDLE_TO_CART):
        case fulfilled(AT.CHECKOUT_RESET_MEMBER):
        case fulfilled(RETAILER_AT.RETAILER_SET_CUSTOMER_DETAILS):
        case fulfilled(RETAILER_AT.RETAILER_ADD_EXTERNAL_HARDWARE):
            if (_isUndefined(action.payload.subscriptions) && !_isNull(action.payload.subscriptions)) {
                return state;
            }
            return _mapValues(action.payload.subscriptions, (sub, key) => ({
                ...state[key],
                ...sub,
            }));
        case fulfilled(AT.CHECKOUT_REMOVE_SERVICE_FROM_CART): {
            return _mapValues(action.payload.subscriptions, (sub, key) => ({
                ...state[key],
                ...sub,
                phoneNumber: {
                    ...state[key].phoneNumber,
                },
            }));
        }

        case pending(RETAILER_AT.RETAILER_SET_PREPAID_WITH_STARTPAKKE): {
            const { subscriptionId, isPrepaidWithStartpakke } = action.meta;
            if (!state[subscriptionId]) return state;
            return {
                ...state,
                [subscriptionId]: {
                    ...state[subscriptionId],
                    isPrepaidWithStartpakke,
                },
            };
        }
        case AT.CHECKOUT_SET_SELECTED_PHONE_NUMBER:
        case fulfilled(AT.CHECKOUT_CHECK_NEW_MEMBER_PHONE_NUMBER): {
            // Fetch subscription based on id. If no id is provided we use legal subscription
            const id = action.subscriptionId || _get(action, "payload.id") || getLegalSubscriptionId(state);
            const subscription = _get(state, `${id}`, null);
            const responseSubscription = action.payload?.subscriptions?.[id] || null;

            if (_isEmpty(subscription)) {
                return state;
            }

            const newSubscription = subscriptionReducer(subscription);
            const phoneNumber = phoneNumberReducer(subscription.phoneNumber, action);

            return {
                ...state,
                [id]: {
                    ...newSubscription,
                    phoneNumber,
                    changeType: _get(action, "payload.changeType"),
                    changedServices: _get(action, "payload.changedServices"),
                    oldSubscription: _get(action, "payload.oldSubscription"),
                    keepExistingSubscription: !!_get(responseSubscription, "keepExistingSubscription"),
                },
            };
        }
        default:
            return state;
    }
};

export default reducer;
